import React from "react";
import "./CabRates.css";

const CabRates = () => {

const rows = [
["SWIFT DESIRE A/C CAB BSVI 2024",2500,3000,3500,13,150,13,500,"RS,700/-","RS,700/-","RS,700/-","RS,700/-","RS,700/-","RS,700/-"],
["ERTIGA A/C CAB 6 SEATER BSVI 2025",3000,3500,4000,17,200,17,500,"RS,700/-","RS,700/-","RS,700/-","RS,700/-","RS,700/-","RS,700/-"],
["INNOVA A/C CAB 8 SEATER BSIV 2016",3000,3500,4500,18,200,18,500,"RS,2000/-","RS,2000/-","RS,2000/-","RS,2000/-","RS,2000/-","RS,2000/-"],
["CRYSTA A/C CAB 8 SEATER BSVI 2024",3500,4300,5000,20,250,20,500,"RS,2000/-","RS,2000/-","RS,2000/-","RS,2000/-","RS,2000/-","RS,2000/-"],
["HYCROSS A/C CAB 8 SEATER BSVI 2026",4000,5000,6000,23,300,23,500,"RS,2000/-","RS,2000/-","RS,2000/-","RS,2000/-","RS,2000/-","RS,2000/-"],
["12 SEATER TEMPO TRAVELLER A/C COACH BSVI 2023",5000,5500,7000,27,250,27,700,"RS,3500/-","RS,3500/-","RS,4000/-","RS,3500/-","RS,3500/-","RS,3500/-"],
["12 SEATER 1X1 URBANIA PREMIUM MAHARAJA LUXURY A/C COACH BSVI 2026",8000,10000,12000,43,500,43,900,"RS,3500/-","RS,3500/-","RS,4000/-","RS,3500/-","RS,3500/-","RS,3500/-"],
["13 SEATER FORCE URBANIA LUXURY A/C COACH BSVI 2024",7000,8000,9000,33,300,33,900,"RS,5000/-","RS,10500/-","RS,13000/-","RS,5000/-","RS,5000/-","RS,5000/-"],
["16 SEATER FORCE URBANIA LUXURY A/C COACH BSVI 2024",7500,8500,9500,38,350,38,1000,"RS,6500/-","RS,13000/-","RS,17000/-","RS,6500/-","RS,6500/-","RS,6500/-"],
["17 SEATER TEMPO TRAVELLER A/C COACH BSVI 2023",6000,6500,7000,32,300,32,800,"RS,6500/-","RS,13000/-","RS,16700/-","RS,6500/-","RS,6500/-","RS,6500/-"],
["22 SEATER BHARAT BENZ LUXURY A/C COACH BSVI 2023",9000,10000,11000,48,500,48,1000,"RS,8500/-","RS,17000/-","RS,22000/-","RS,8500/-","RS,8500/-","RS,8500/-"],
["28 SEATER BHARAT BENZ LUXURY A/C COACH BSVI 2023",10000,11000,12000,52,500,52,1100,"RS,11000/-","RS,22000/-","RS,28000/-","RS,11000/-","RS,10500/-","RS,10500/-"],
["33 SEATER BHARAT BENZ LUXURY A/C COACH BSVI 2022",10500,11500,12500,55,500,55,1100,"RS,12500/-","RS,25000/-","RS,33000/-","RS,12000/-","RS,12000/-","RS,12000/-"],
["40 SEATER ASHOK LEYLAND EXECUTIVE A/C COACH BSVI 2025",10500,12000,13000,65,500,65,1200,"RS,15000/-","RS,30000/-","RS,38000/-","RS,15000/-","RS,15000/-","RS,15000/-"],
["45 SEATER ASHOK LEYLAND LUXURY A/C COACH BSVI 2026",11500,13000,14000,70,500,70,1200,"RS,16000/-","RS,33000/-","RS,45000/-","RS,16000/-","RS,16000/-","RS,16000/-"],
["49 SEATER ASHOK LEYLAND EXECUTIVE A/C COACH BSIV 2017",10500,12000,13500,63,500,63,1200,"RS,19500/-","RS,37000/-","RS,50000/-","RS,19500/-","RS,19500/-","RS,19500/-"],
["49 SEATER ASHOK LEYLAND EXECUTIVE NON A/C COACH BSIV 2017",8500,10000,12000,53,500,53,1200,"RS,19500/-","RS,37000/-","RS,50000/-","RS,19500/-","RS,19500/-","RS,19500/-"]
];

const termsText = `TERMS & CONDITIONS
PLEASE NOTE: That Rates Quoted To You Are Subject To Cab & Coach Availability & We Have Not Blocked Any Cab & Coach After Receiving Any Confirmation From U.

BOOKING PROCEDURE
Your Contract Is With HYDERABAD TOURS AND TRAVELS. A Contract Exists Between Us When We Have Confirmed You On Our Tour / Hotel Booking / Or Any Other Travel Related Services Of Your Choice And We Have Received Your Booking Request And Deposits. All Correspondence/S In Respect Of Tours / Travel Service Bookings Should Be Addressed To M/S. HYDERABAD TOURS AND TRAVELS

PAYMENTS PROCEDURE
We trust all the above is acceptable to you and shall look forward to a great business association with your organization. Or The Services Contracted, 50% Advance Payment Should Be Made To Hold The Booking On A Confirmed Basis And The Balance Amount Should Be Paid Before Commencement Of Your Tour. We Hold The Right To Decide Upon The Amount To Be Paid As An Advance Payment, Based On The Nature Of Services And The Time Left For The Commencement Of The Services. Apart From The Above, In Some Cases, Like Special Train Journeys Like Palace On Wheels, Cab & Coach Bookings During The High Peak Tourist Season (X-Mas, New Year), Full Payment Is Required To Be Sent In Advance.

In case of a bill to a company, an authorization letter to be sent on the company letterhead or from the official email stating the details of the reservation. All bills should be cleared within 7 days of receipt bills, Post which payment will attract a charge of 1.5% rate of interest.

PAYMENT OPTIONS
Payment Can Be Made By Credit Card Through Our Secured Online Payment Gateway System, By Bank Transfer, Cash Payment To Our Offices In Your City Or By Demand Draft / Cheque. All Payments Should Be Free And Clear Of Any Withholding Tax And Deduction. Bank Charges, If Any, For Remittance (By Remitting Bank Or By Intermediary Bank) Would Be Strictly Borne By the Payer.

RIGHTS TO AMEND THE ITINERARY IF REQUIRED
Tour Once Commenced, Will Strictly Go As Per The Itinerary Finalized. In Case Of Events And Circumstances Beyond Our Control, We Reserve The Right To Change All Or Parts Of The Contents Of The Itinerary For Safety And Well-Being Of Our Esteemed Passengers.

CANCELLATION POLICY
All cancellations must be intimated to our head office by phone followed by a written confirmation via email or fax. Telephonic cancellations will not be accepted as ‘cancellation requests’. The cancellation in case of group booking should be made at least 30 days prior to the date of commencement of the trip. For Christmas, New Year, Diwali & other important festivals, the normal cancellation policy does not apply and payments against bookings during such a busy period are considered as non-refundable.

CANCELLATION CHARGES PER PERSON WILL BE APPLICABLE AS FOLLOWS:
60 Days & Prior to Arrival — 10% of the Tour/Service Cost.
59 Days to 30 Days Prior To Arrival - 20% of the Tour/Service Cost.
29 Days to 15 Days Prior To Arrival - 25% of the Tour/Service Cost.
14 Days to 08 Days Prior To Arrival - 50% of the Tour/Service Cost.
07 Days & Less, Prior to Arrival or No Show — No Refund.`;

return (
<div className="transportPage">

<div className="topHeader">
B2B RATES VALID UPTO TILL MARCH 2027  
CALL 24/7 +91 9701238500, +91 8008433898
</div>


<div className="tableWrapper">
<table className="cabTable">
<thead>
<tr>
<th className="tableHeading">TYPE OF CARS & COCHES</th>
<th>8 HRS - 80 KM</th>
<th>10 HRS - 100 KM</th>
<th>12 HRS - 120 KM</th>
<th>EXTRA KMS</th>
<th>EXTRA HRS</th>
<th>OUT STATION MINIMUM 300 KM AVRAGE PER DAY</th>
<th>DRIVER BHATHA PER DAY</th>
<th>ANDHRA STATE TAX 7 DAYS VALID ONLY</th>
<th>KARNATAKA STATE TAX 7 DAYS VALID ONLY</th>
<th>TAMLINADU STATE TAX 7 DAYS VALID ONLY</th>
<th>KERALA STATE TAX 7 DAYS VALID ONLY</th>
<th>MAHARASHTRA STATE TAX 7 DAYS VALID ONLY</th>
<th>GOA STATE TAX 7 DAYS VALID ONLY</th>
</tr>
</thead>

<tbody>
{rows.map((row,i)=>(
<tr key={i}>
{row.map((cell,index)=>(<td key={index}>{cell}</td>))}
</tr>
))}
</tbody>

</table>
</div>

{/* NOTES SECTION */}
<div className="notes">
<p><b>NOTE:</b> TOLL GATE PARKING INCLUDING AS PER ABOVE RATES</p>
<p><b>NOTE:</b> BEFORE 6:00 AM AFTER 11:00 PM DRIVER BATA @ 200/-</p>
<p><b>NOTE:</b> AFTER 00:00 HRS. CAB CONTINUE AND WILL BE CALCULATED PER ANOTHER SLAB</p>
<p><b>NOTE:</b> VEHICLE TIME & RIDING STARTING AND CLOSING WILL BE GARAGE TO GARAGE</p>
<p><b>NOTE:</b> 5% GST WILL BE CHARGED AS PER THE GOVT. RULES ON GROSS BILLING AMOUNT</p>
</div>

<div className="notes">
<p><b>NOTE:</b> TOLL GATE PARKING STATE TAX EXTRA AS PER</p>
<p><b>NOTE:</b> BEFORE 6:00 AM AFTER 10:00 PM DRIVER BATA @ 200/-</p>
<p><b>NOTE:</b> AFTER 00:00 HRS. CAB CONTINUE AND WILL BE CALCULATED PER ANOTHER SLAB</p>
<p><b>NOTE:</b> VEHICLE TIME & RIDING STARTING AND CLOSING WILL BE GARAGE TO GARAGE</p>
<p><b>NOTE:</b> 5% WILL BE CHARGED AS PER THE GOVT. RULES ON GROSS BILLING AMOUNT</p>
</div>



<div className="termsBox">
<pre className="termsText">{termsText}</pre>
</div>

<div className="finalSection">

  <div className="highlightBox">
    <h3>⚠️ IMPORTANT NOTICE</h3>
    <p>
      Irrespective Of The Above-Mentioned Cancellations Slabs — In Case Of Cancellation Of Tour Services
      After The Booking Is Made With Us, A Minimum <b>10% Service Charges</b> Would Be Applicable.
    </p>

    <p>
      In Case You Cancel The Trip After Commencement, The Refund Would Be Restricted To A Limited Amount.
      That Too Would Depend On The Amount That We Would Be Able To Recover From The Hoteliers We Patronize.
      For Unused Hotel Accommodation, Chartered Transportation And Missed Meals Etc. We Do Not Bear Any Responsibility To Refund.
    </p>
  </div>

  <div className="refundBox">
    <h3>💰 REFUND POLICY</h3>
    <p>
      In Regard To Refund Of Unused / Unutilized Services (Which Are Paid For And Canceled In Advance),
      The Refund Amount Would Be Worked Out On The Basis Of Cancellation Policy As Described Above And The Money
      Would Accordingly Be Refunded To The Person Who Has Made The Payment To Us.
    </p>

    <p>
      Please Note That The Refund Process May Take <b>2–4 Weeks</b> Due To Banking Procedures.
      If The Refund Is Made To The Credit Card Account Or To A Bank Account, The Bank Charges Would Be Debited From The Refund Amount.
    </p>
  </div>

  <div className="agreementBox">
    <p>
      <b>Note:</b> If the above is acceptable to you, please return a copy of this agreement by signing on each page,
      thus enabling us to load your special rates into our system. This offer remains valid until <b>31.03.2027</b>.
    </p>
  </div>

  <div className="companyBox">
    <h2>HYDERABAD TOURS AND TRAVELS™</h2>

    <p><b>Sales Office Address:</b><br/>
    # 5 - 9 - 101/D, Assembly Metro Station, P NO. A 1253, Opp. Public Gardens, Nampally, Hyderabad Ts, 500001
    </p>

    <div className="signatureBox">
      <p><b>Name:</b> MARUTHI MHETRE</p>
      <p><b>Designation:</b> Founder Chairman & Managing Director</p>
      <p><b>Date:</b> 01/03/2026</p>
    </div>
  </div>

  <div className="contactGrid">

    <div>
      <h4>GIT & MICE</h4>
      <p>Mr Maruthi</p>
      <p>+91 - 9701238500</p>
      <p>+91 - 8008433898</p>
    </div>

    <div>
      <h4>FIT & GIT</h4>
      <p>Mrs Malashree</p>
      <p>+91 - 9000308958</p>
      <p>+91 - 9666000030</p>
    </div>

    <div>
      <h4>Transport</h4>
      <p>Ms Swapna</p>
      <p>+91 - 9133100093</p>
      <p>+91 - 9133100094</p>
    </div>

    <div>
      <h4>Executive</h4>
      <p>Mr Sandeep</p>
      <p>+91 – 9133100091</p>
    </div>

    <div>
      <h4>Holiday Packages</h4>
      <p>Ms Sangita</p>
      <p>+91 - 9133100092</p>
    </div>

  </div>

  <div className="footerDetails">
    <p><b>PAN NO:</b> BIJPM2951C</p>
    <p><b>GST NO:</b> 36BIJPM2951C1ZD</p>

    <p className="emails">
      sales@hyderabadtoursandtravels.com<br/>
      dmc@hyderabadtoursandtravels.com<br/>
      b2b@hyderabadtoursandtravels.com<br/>
      booking@hyderabadtoursandtravels.com
    </p>

    <p className="website">
      www.hyderabadtoursandtravels.com
    </p>
  </div>

</div>

</div>
);
};

export default CabRates;